import React, { useState } from 'react';
import { gql, useMutation, useQuery } from "@apollo/client";
import Tarjeta from './Tarjeta';
import '../App.css';

const GET_TARJETAS = gql`
query getTarjetas {
    getTarjetas {
        numeroTarjeta
        cvv
        contrasena
        nombreTitular
        contactoTitular
    }
}`;

const AGREGAR_TARJETA = gql`
mutation crearTarjeta($nombreTitular: String!, $contactoTitular: String!, $numeroTarjeta: String!, $cvv: String!, $contrasena: String!) {
    crearTarjeta(nombreTitular: $nombreTitular, contactoTitular: $contactoTitular, numeroTarjeta: $numeroTarjeta, cvv: $cvv, contrasena: $contrasena) {
        numeroTarjeta
        cvv
        contrasena
        nombreTitular
        contactoTitular
    }
}`;

function GetTarjetas() {
    const [nombreTitular, setNombreTitular] = useState('');
    const [contactoTitular, setContactoTitular] = useState('');
    const [numeroTarjeta, setNumeroTarjeta] = useState('');
    const [cvv, setCvv] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [filter, setFilter] = useState('');
    const [crearTarjeta] = useMutation(AGREGAR_TARJETA, {
        refetchQueries: [{ query: GET_TARJETAS }],  // Refresca la lista de tarjetas después de agregar una nueva
    });

    const tarjetaSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await crearTarjeta({
                variables: { nombreTitular, contactoTitular, numeroTarjeta, cvv, contrasena }
            });
            if (data) {
                setNombreTitular('');
                setContactoTitular('');
                setNumeroTarjeta('');
                setCvv('');
                setContrasena('');
            }
        } catch (error) {
            console.error("Error al agregar tarjeta:", error);
        }
    };

    const { loading, error, data } = useQuery(GET_TARJETAS);
    if (loading) return <p>Esperando resultados...</p>;
    if (error) return <p>Error: {error.message}</p>;

    

    const reversedData = data.getTarjetas.slice().reverse();

    const filteredData = data.getTarjetas.filter(tarjeta => 
        tarjeta.nombreTitular.toLowerCase().includes(filter.toLowerCase()) ||
        tarjeta.numeroTarjeta.includes(filter) ||
        tarjeta.cvv.includes(filter)
    );

    return (
        <div>
              <input
                type="text"
                placeholder="Filtrar tarjetas"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
            />
            {filteredData.map((tarjeta, index) => (
                <Tarjeta
                    key={index}
                    nombreTitular={tarjeta.nombreTitular}
                    numeroTarjeta={tarjeta.numeroTarjeta}
                    cvv={tarjeta.cvv}
                    contactoTitular={tarjeta.contactoTitular}
                />
            ))}
          {/*} {reversedData.map((tarjeta, index) => (
                <Tarjeta
                    key={index}
                    nombreTitular={tarjeta.nombreTitular}
                    numeroTarjeta={tarjeta.numeroTarjeta}
                    cvv={tarjeta.cvv}
                    contactoTitular={tarjeta.contactoTitular}
                />
            ))}*/}
            <form onSubmit={tarjetaSubmit}>
                <input placeholder='nombreTitular' value={nombreTitular} onChange={evt => setNombreTitular(evt.target.value)} />
                <input placeholder='contactoTitular' value={contactoTitular} onChange={evt => setContactoTitular(evt.target.value)} />
                <input placeholder='numeroTarjeta' value={numeroTarjeta} onChange={evt => setNumeroTarjeta(evt.target.value)} />
                <input placeholder='cvv' value={cvv} onChange={evt => setCvv(evt.target.value)} />
                <input placeholder='contrasena' value={contrasena} onChange={evt => setContrasena(evt.target.value)} />
                <button className="btn btn-salida" type="submit">Agregar Tarjeta</button>
            </form>
        </div>
    );
}

export default GetTarjetas;
